// Формат цены: 1200 → «1 200», 11680.5 → «11 680.50».
// Разделитель тысяч — узкий пробел (U+2009), тоньше обычного.

export const formatPrice = (value) => {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).replace(/[\s  ]/g, ' ');
};
